import { useState, useCallback, useEffect } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { Employee } from 'src/types/Employee';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { getEmployee } from 'src/components/enterprise/features/Employee/EditPage/api/getEmployeeAPI';
import { transformEmployeeModelToForm } from 'src/components/enterprise/features/Employee/utils/employee.utils';

export type UseGetEmployeeReturnType = {
  isLoading: boolean;
  hasError?: boolean;
  employeeData?: Employee;
  employeeFormValues?: EmployeeFormFields;
};

export const useGetEmployee = (
  corpId: string,
  employeeId: string
): UseGetEmployeeReturnType => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState<boolean>();
  const [employeeData, setEmployeeData] = useState<Employee>();
  const [employeeFormValues, setEmployeeFormValues] =
    useState<EmployeeFormFields>();

  const getEmployeeTrigger = useCallback(async (): Promise<void> => {
    try {
      setIsLoading(true);
      setHasError(false);

      const employeeModel = await getEmployee(corpId, employeeId);
      const employeeForm = transformEmployeeModelToForm(employeeModel);

      setEmployeeData(employeeModel);
      setEmployeeFormValues(employeeForm);
    } catch (err) {
      setHasError(true);
      pushErrorFromAPI(err);
    } finally {
      setIsLoading(false);
    }
  }, [corpId, employeeId]);

  useEffect(() => {
    getEmployeeTrigger();
  }, [getEmployeeTrigger]);

  return {
    isLoading,
    hasError,
    employeeData,
    employeeFormValues,
  };
};
